var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ifac-maintenance-page',{attrs:{"loading":_vm.isRetrying,"on-retry":_vm.retry}})
}
var staticRenderFns = []

export { render, staticRenderFns }